export default "__VITE_ASSET__592dcb78__"